import { STATUS_META } from "@/lib/mh";
import { cn } from "@/lib/utils";

export const StatusDot = ({ status, cls }) => {
  const m = STATUS_META[status] || STATUS_META.not_started;
  return (
    <span
      className={cn("inline-block w-2 h-2 rounded-full flex-shrink-0", status === "live" && "mh-pulse", cls)}
      style={{ background: m.color, color: m.color }}
      title={m.label}
    />
  );
};

export const StatusPill = ({ status, testId }) => {
  const m = STATUS_META[status] || STATUS_META.not_started;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border border-white/10 bg-white/[0.03] font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
      <StatusDot status={status} />
      {m.label}
    </span>
  );
};

export const DeptTag = ({ dept, name, hex, cls }) => (
  <span className={cn("inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em]", cls)} style={{ color: hex }}>
    <span className="w-1.5 h-1.5 rotate-45" style={{ background: hex }} />
    {name || dept}
  </span>
);

export const Eyebrow = ({ children, cls }) => (
  <div className={cn("font-mono text-[10px] uppercase tracking-[0.28em] text-muted-foreground", cls)}>{children}</div>
);

export const Panel = ({ children, cls, testId, style }) => (
  <section data-testid={testId} style={style} className={cn("rounded-xl border border-white/[0.07] bg-[#0A0A0F]/80 backdrop-blur-xl", cls)}>
    {children}
  </section>
);

export const Stat = ({ label, value, sub, testId, accent }) => (
  <div data-testid={testId} className="min-w-0">
    <Eyebrow>{label}</Eyebrow>
    <div className="font-display text-4xl sm:text-5xl leading-none mt-2 tabular-nums" style={accent ? { color: accent } : undefined}>{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1.5 font-mono">{sub}</div>}
  </div>
);

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
